import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "Q3831",
    isNumber: true,
    isSum: true,
  },
];

export const AreaToHighRiskFactor = {
  label: "場域 VS 高風險因子",
  key: "AreaToHighRiskFactor",
  path: "BoneMuscleCare/AreaToHighRiskFactor",
  api: "TCS_V_HighRiskStatics01V",
  render: (options) => (
    <Diagram.BoneMuscleCare.AreaToHighRiskFactor {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "Q3812",
      field: "Q3812",
      header: "",
    },
  ],
  filterColumns: [{ key: "Q3967", type: "date" }],
  levelColumns,
  columns: [],
};
